//#region src/helpers.ts
function convertHumanToUser(human, trackError) {
	if (!human.email) {
		const message = "invalid data returned: missing Human.email";
		trackError && trackError(message);
		return {
			state: "error",
			user: void 0,
			message
		};
	}
	const fullName = human.full_name || human.first_name || "Customer";
	const firstName = human.first_name || human.full_name || "Customer";
	const hasOpendoorEmail = human.email.endsWith("@opendoor.com");
	const hasOpendoorInternalAccess = human.opendoor_internal_access || false;
	const impersonated = human.impersonated || false;
	return {
		state: "authenticated",
		user: {
			humanToken: human.token,
			customerUuid: human.customer_uuid || null,
			email: human.email,
			fullName,
			firstName,
			hasOpendoorEmail,
			hasOpendoorInternalAccess,
			primaryPhone: human.primary_phone || null,
			impersonated
		}
	};
}
var parseAuthentication = (queryResult, trackError) => {
	if (queryResult.loading) return {
		state: "authenticating",
		user: void 0
	};
	if (queryResult.error) {
		trackError && trackError("UserSession error", queryResult.error);
		return {
			state: "error",
			user: void 0,
			message: queryResult.error.message
		};
	}
	const userSession = queryResult.data?.web.userSession;
	if (!userSession) {
		const message = "invalid data returned: missing UserSession";
		trackError && trackError(message);
		return {
			state: "error",
			user: void 0,
			message
		};
	}
	if (!userSession.human) return {
		state: "not_authenticated",
		user: null
	};
	return convertHumanToUser(userSession.human, trackError);
};
//#endregion
export { parseAuthentication };

